import React, { Component, Fragment } from 'react';
import './PointSpendLog.less'
import * as Func from '../../../../../../helpers/functions';
import {
    FormWrapperItem, ListComponent, StatusComponent,
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import { Button, Collapse, Icon, Modal, Skeleton } from 'antd';
import Order, { PointHistory } from '../../../../../../models/Order';
import { ORDER } from 'constants/Define';

const { Panel } = Collapse;

const removedColumns = [
    'id', 'orderId', 'orderCode', 'createdDate', 'vgId', 'type', 'orderRefundStatus', 'refundBy', 'refundAt',
];
const spendLogItemKeys = Object.getOwnPropertyNames(new PointHistory());
export default class PointHistories extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: this.getTitleTable(),
            modelItem: spendLogItemKeys,
            componentTable: {
                PropertyCode: {
                },
                amount: {

                },
                sessionId: {
                    key: 'sessionId',
                    width: 300,
                    render: (value, record) => {
                        return value;
                    }
                },
                status: {
                    key: 'status',
                    align: "center",
                    render: (value, record) => {
                        const orderRefundConfig = {
                            2: { color: 'orange', label: 'item.order.pointHistory.orderRefundStatusType.confirmed' },
                            5: { color: 'red', label: 'item.order.pointHistory.orderRefundStatusType.refundFailed' }
                        };

                        if (orderRefundConfig[record.orderRefundStatus]) {
                            const config = orderRefundConfig[record.orderRefundStatus];
                            return <StatusComponent
                                color={config.color}
                                label={this.props.t(config.label)}
                            />
                        }

                        return <Fragment>
                            <StatusComponent color={value ? 'green' : 'red'}
                                label={this.props.t(value ? `item.order.pointHistory.statusTypes.success` : `item.order.pointHistory.statusTypes.failed`)} />
                        </Fragment>
                    },
                },
                refundStatus: {
                    key: 'refundStatus',
                    align: "center",
                    render: (value, record) => {
                        return <Fragment>
                            {
                                value &&
                                <StatusComponent color={'green'}
                                    label={this.props.t(`item.order.pointHistory.statusTypes.success`)} />
                            }
                        </Fragment>
                    },
                },
                operator: {
                    key: "operator",
                    render: (value, record) => {
                        const { refundBy, refundAt } = record;

                        return (
                            <div className='refund-info'>
                                {refundBy && (
                                    <div className='refund-by'>
                                        {refundBy}
                                    </div>
                                )}
                                {refundAt && (
                                    <>
                                        <div className='refund-at'>
                                            {new Date(refundAt + 'Z').toLocaleTimeString('vi-VN', {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: false
                                            })}
                                        </div>
                                        <div className='refund-at'>
                                            {new Date(refundAt + 'Z').toLocaleDateString('vi-VN', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })}
                                        </div>
                                    </>
                                )}
                            </div>
                        );
                    }
                },
                operation: {
                    key: "operation",
                    align: "center",
                    render: (value, record) => {
                        return <div className='refund-action'>
                            <Button className='btn-refund' onClick={() => this.showRefundModal(record)} disabled={record.orderRefundStatus == 2}>
                                <Icon type="redo" disabled={record.orderRefundStatus == 2} />
                            </Button>
                        </div>
                    }
                },
            },
            isRefunding: false,
            isRefundModalVisible: false,
            refundOrder: {},
        };
    }

    getTitleTable = () => {
        const { permisions, order } = this.props;
        const baseColumns = [...spendLogItemKeys];
        
        if (order && order.itemTypes == ORDER.TYPES.HOTEL.id && permisions.allowRefund) {
            baseColumns.push("operator", "operation");
        }
        
        return Func.getTitleTable(baseColumns, [], removedColumns);
    }

    componentDidUpdate(prevProps) {
        const { orderState, getPointHistories, order } = this.props;
        const { refundPointSuccess, isFetchingRefunOrderPoint } = orderState;
        const { refundOrder } = this.state;

        if (prevProps.order !== order) {
            this.setState({
                titleItemTable: this.getTitleTable()
            });
        }

        if (prevProps.orderState.isFetchingRefunOrderPoint && !isFetchingRefunOrderPoint) {
            if (refundPointSuccess) {
                this.handleRefundSuccess();
            } else {
                this.handleRefundFail();
            }
            getPointHistories(refundOrder.orderId);
        }
    }

    showRefundModal = (data) => {
        this.setState({
            isRefundModalVisible: true,
            refundOrder: data,
        })
    }

    cancelRefund = () => {
        this.setState({
            isRefundModalVisible: false,
        })
    }

    confirmRefund = () => {
        const { refundOrderPoint } = this.props;
        const { refundOrder } = this.state;

        this.setState({
            isRefundModalVisible: false,
            isRefunding: true
        })

        refundOrderPoint(refundOrder.id);
    }

    handleRefundSuccess = () => {
        const { t } = this.props;
        const { refundOrder } = this.state;

        this.setState({
            isRefunding: false,
            isRefundModalVisible: false
        });

        Modal.success({
            title: t('item.order.pointHistory.refundSuccess'),
            content: `Đã hoàn ${refundOrder?.amount} điểm cho đơn ${refundOrder.orderCode}`,
            centered: true,
            okText: t('action.close'),
            onOk: () => {
                Modal.destroyAll();
            },
        });
    }

    handleRefundFail = () => {
        this.setState({ isRefunding: false });
        this.showRefundFailModal();
    }

    showRefundFailModal = () => {
        const { t, orderState } = this.props;
        const { refundPointError } = orderState;

        Modal.confirm({
            title: t('item.order.pointHistory.refundFail'),
            content: refundPointError || t('item.order.pointHistory.refundFailContent'),
            icon: <Icon type="close-circle" style={{ color: '#ff4d4f' }} />,
            centered: true,
            cancelText: t('action.close'),
            okText: t('action.retry'),
            onCancel: () => {
                Modal.destroyAll();
            },
            onOk: () => {
                Modal.destroyAll();
                setTimeout(() => this.confirmRefund(), 100);
            },
        });
    }

    render() {
        const { t, spendHistories, loading } = this.props;
        const { titleItemTable, modelItem, componentTable, isRefundModalVisible, refundOrder, isRefunding } = this.state;

        return (
            <Fragment>
                <Collapse className='my-3 w-100' style={{ backgroundColor: "white" }} bordered={false} expandIconPosition='right'>
                    <Panel header={
                        <h3 className={`m-0`} style={{ color: "#676a6c" }}>{t('item.order.pointHistory.spendLog')}</h3>
                    } key="1">
                        <Wrapper className="col-md-12 sms-histories-section">
                            <Wrapper className={`row mt-2 mb-3`}>
                                <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
                                    {(!loading || !isRefunding) ?
                                        <ListComponent
                                            classParent="m-0 p-0 col-md-12"
                                            marginTop={'0'} marginBottom={'0'}
                                            loading={{ spinning: loading || isRefunding, size: 'large' }}
                                            rowKey={(record, k) => k}
                                            dataSource={Func.getDataSource(spendHistories, modelItem)}
                                            columns={Func.columnsTable({
                                                titleTable: titleItemTable,
                                                component: componentTable,
                                                itemName: 'order.pointHistory'
                                            })}
                                            componentTableList={{}}
                                            hideSettings={true}
                                        />
                                        : <Skeleton active paragraph={{ row: 3 }} className="p-4" />
                                    }
                                </FormWrapperItem>
                            </Wrapper>
                        </Wrapper>
                    </Panel>
                </Collapse>
                <Modal
                    visible={isRefundModalVisible}
                    onOk={this.confirmRefund}
                    onCancel={this.cancelRefund}
                    className='refund-modal'
                    width={600}
                    centered
                    footer={[
                        <Button key="back" onClick={this.cancelRefund}>
                            {t('action.cancel')}
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.confirmRefund}>
                            {t('action.confirm')}
                        </Button>,
                    ]}
                >
                    <Icon type="exclamation-circle" />
                    <h3>{t('item.order.pointHistory.refundModal.title')}</h3>
                    <p>
                        {t("item.order.pointHistory.refundModal.message")}
                        <strong>{refundOrder?.orderCode}</strong>?
                    </p>
                    <p>
                        {t('item.order.pointHistory.refundModal.pointAmount')}
                        <strong>
                            {refundOrder?.amount}
                            {t('item.order.pointHistory.refundModal.point')}
                        </strong>
                    </p>
                    <p>{t('item.order.pointHistory.refundModal.warning')}</p>
                </Modal>
            </Fragment>
        );
    }
}

PointHistories.defaultProps = {
    spendHistories: [],
    loading: false,
    permisions: {},
    order: new Order(),
};
